function texto(valor) {
  if (valor == null) return '';
  const linha = String(valor).trim();
  if (!linha || linha === 'undefined' || linha === 'null') return '';
  return linha;
}

function primeiroTexto(...valores) {
  for (let i = 0; i < valores.length; i += 1) {
    const linha = texto(valores[i]);
    if (linha) return linha;
  }
  return '';
}

export function enderecoDoPoste(properties) {
  const props = properties || {};
  const pronto = primeiroTexto(props.enderecoCompleto, props.endereco);
  if (pronto) return pronto;
  const via = [primeiroTexto(props.logradouro, props.rua), primeiroTexto(props.numeroLogradouro, props.numero)]
    .filter(Boolean)
    .join(', ');
  if (!via) return '';
  const local = [texto(props.bairro), texto(props.municipio)].filter(Boolean).join(', ');
  return local ? `${via} - ${local}` : via;
}

export function urlGoogleMaps(latitude, longitude) {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return '';
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${lat},${lng}`)}`;
}

export function linhasDaFichaDoServico(properties, coordinates) {
  const props = properties || {};
  const linhas = [];
  const push = (label, value) => {
    const valor = texto(value);
    if (valor) linhas.push({ label, value: valor });
  };
  push('Serviço', props.servico);
  push('Município', props.municipio);
  push('Endereço', enderecoDoPoste(props));
  push('Logradouro', primeiroTexto(props.logradouro, props.rua));
  push('Núm. logradouro', primeiroTexto(props.numeroLogradouro, props.numero));
  push('Bairro', props.bairro);
  push('Material', primeiroTexto(props.tipoPoste, props.material));
  push('Situação', props.situacaoPoste);
  const coords = Array.isArray(coordinates) ? coordinates : null;
  if (coords && coords.length >= 2 && props.rotuloFicha) {
    push('Latitude', coords[1]);
    push('Longitude', coords[0]);
  }
  push('Quantidade', props.qtd);
  push('Resultado', props.resultadoAuditoria);
  push('Observação', props.observacao);
  return linhas;
}

export function urlGoogleMapsDaFicha(properties, coordinates) {
  const props = properties || {};
  if (!props.rotuloFicha) return '';
  const coords = Array.isArray(coordinates) ? coordinates : null;
  if (!coords || coords.length < 2) return '';
  return urlGoogleMaps(coords[1], coords[0]);
}
